import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { apiThatThrows } from "../api";

export function useOrganizationsApi() {
  const dispatch = useDispatch();

  const getOrganizationPublicInfo = useCallback(
    (id) => {
      return dispatch(
        apiThatThrows.getOrganizationPublicInfo.action({
          params: { organizationId: id },
        })
      );
    },
    [dispatch]
  );

  return {
    getOrganizationPublicInfo,
  };
}
